// Stepper.jsx

import { useState, useEffect, Fragment } from 'react';
import './App.css'

import CheckSVG from './images/check.svg';

import { CourseCardIcon } from './CourseCardIcon';
import { CourseFormCard } from './CourseFormCard';
import { PROVIDER_ID } from './Constant';
import { Preloader } from './Preloader';


const Line = () => (
  <div className="line">
    <div className="dashed-line" />
  </div>
);

const SectionTitle = ({ title, paragraph }) => {
  return (
    <div className="section-title">
      <h2 className="title">{title}</h2>
      <p className="paragraph">{paragraph}</p>
    </div>
  );
};

const SelectCourseCard = ({
  title,
  onClickCard,
  isSelected,
  code,
  showCheckbox = true,
  selectedDeliveryTime,
  handleCheckboxChange
}) => {
  let formattedTitle = title;

  if (title === "Fulltime" || title === "Parttime") {
    formattedTitle = title.replace(/.{4}$/, '-$&');
  }

  const handleClick = (selectedTitle) => {
    onClickCard(selectedTitle);

    if (handleCheckboxChange) {
      const event = { target: { value: selectedTitle } }
      handleCheckboxChange(event)
    }
  };



  return (
    <>
      <div className="card card-margin course-type" onClick={() => handleClick(title)}>
        <div className="card-header no-border"
          style={{ marginBottom: "-30px" }}
        >
          <button className={`rounded-button ${isSelected && "selected"}`}>{`${isSelected ? "Selected" : "Select"
            }`}</button>
        </div>
        <div className="card-body course-type-body">
          <div className="widget-49">
            <div className="widget-49-title-wrapper">
              <div className="widget-49-date-primary">
                <span className="widget-49-date-day"><CourseCardIcon title={title} /></span>
              </div>
              <div className="widget-49-meeting-info">
                <span className="widget-49-pro-title">
                  <strong>{formattedTitle}</strong>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const Stepper1 = (props) => {
  return (
    <div className="step step-1">
      <div className="head-container">
        <SectionTitle
          title="Select Your Course Type"
          paragraph={<Fragment>We offer a wide range of full-time and part-time courses across Longford and Westmeath. <br /><br />
            Our full-time courses are either classroom based or online during the day. Our part time courses are more flexible, courses are offered during the day, online or in the evening.</Fragment>}
        />
        <div className='d-flex justify-content-end align-items-center gap-2'>
          <button
            disabled={!props.selectedCourseType}
            onClick={props.handleNext}
            className="next-rounded-button"
          >
            Next
          </button>
        </div>
      </div>
      <div className='section group'>
        {props.data.courseType
          .map((courseType) => (
            <div className='col span_1_of_2' key={courseType.Id}>
              <SelectCourseCard
                code={courseType.Code}
                id={courseType.Id}
                title={courseType.Description}
                key={courseType.Id}
                isSelected={props.selectedCourseType === courseType}
                selectedDeliveryTime={props.selectedDeliveryTime}
                handleCheckboxChange={props.handleCheckboxChange}
                onClickCard={() => props.handleCourseTypeSelection(courseType)}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

const Stepper2 = (props) => {
  const {
    handleNext,
    handlePrevious,
    selectedInterestArea,
    handleInterestAreaSelection,
    data,
  } = props;
  const [interestAreas, setInterestAreas] = useState([]);
  useEffect(() => {
    fetch(
      "https://service.fetchcourses.ie/service/fetchcourse.svc/json/GetISCEDList"
    )
      .then((res) => res.json())
      .then((data) => setInterestAreas(data.ReferenceList));
  }, []);

  return (
    <div className="step step-2">
      <div className="head-container">
        <SectionTitle
          title="Select Your Area of Interest"
          paragraph={<Fragment>Select the area that interests you and that you want to learn more about. You can choose either one or multiple areas of interest.</Fragment>}
        />
        <div className='d-flex justify-content-end align-items-center gap-2'>
          <button
            onClick={handlePrevious}
            className="prev-rounded-button"
          >
            Previous
          </button>
          <button
            disabled={selectedInterestArea.length === 0}
            onClick={handleNext}
            className="next-rounded-button"
          >
            Next
          </button>
        </div>
      </div>
      <div className='section group'>
        {data.interestArea.map((interestArea) => (
          <div className="col span_1_of_3" key={interestArea.Id}>
            <SelectCourseCard
              id={interestArea.Id}
              title={interestArea.Description}
              key={interestArea.Id}
              showCheckbox={false}
              isSelected={selectedInterestArea.includes(interestArea)}
              onClickCard={() => handleInterestAreaSelection(interestArea)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

const Stepper3 = (props) => {
  const { handlePrevious, children, searchResults, data } = props;
  return (
    <>
      <div className="step step-3">
        <div className="head-container">
          <SectionTitle
            title="Course Results"
            paragraph={<Fragment>If you can’t find your course, don’t worry contact our <b><a target="_blank" rel="noreferrer" href="/guidance/">LWETB FET Guidance and Information Service</a></b>, they will help you find your course.</Fragment>}
          />
          <div className='d-flex justify-content-end align-items-center gap-2'>
            <button
              onClick={handlePrevious}
              className="prev-rounded-button"
            >
              Previous
            </button>
          </div>
        </div>
      </div>
      {children}
    </>
  );
};

export const Stepper = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedCourseType, setSelectedCourseType] = useState(null);
  const [selectedDeliveryTime, setSelectedDeliveryTime] = useState(null);
  const [selectedInterestArea, setSelectedInterestArea] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [inputSearch, setInputSearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const handleNext = () => {
    setCurrentStep(currentStep + 1);
  };

  const handlePrevious = () => {
    setCurrentStep(currentStep - 1);
  };

  console.log("selectedCourseType", selectedCourseType);

  const handleCourseTypeSelection = (courseType) => {
    console.log({ courseType })
    setSelectedCourseType(courseType);
    // setSelectedDeliveryTime('')
    // handleNext();
  };

  const handleInterestAreaSelection = (interestArea) => {
    if (selectedInterestArea.includes(interestArea)) {
      setSelectedInterestArea(
        selectedInterestArea.filter((area) => area !== interestArea)
      );
    } else {
      setSelectedInterestArea([...selectedInterestArea, interestArea]);
    }
  };

  const handleLocationSelection = (location) => {
    console.log(location);
    setSelectedLocation(location);
  };

  const handleCheckboxChange = (event) => {
    setSelectedDeliveryTime(event.target.value);
  };
  const handleSearch = (value) => {
    setInputSearch(value);
    const filteredResults = data.mockResults.filter((result) => {
      return result.title.toLowerCase().includes(value.toLowerCase());
    });
    setSearchResults(filteredResults);
  };

  const isStepCompleted = (step) => {
    if (step === 1) {
      return selectedCourseType !== null;
    } else if (step === 2) {
      return;
    } else if (step === 3) {
      return step === 2; // Assuming step 3 is always completed
    }
    return false;
  };

  const isStepEditable = (step) => {
    return currentStep > step;
  };

  useEffect(() => {
    Promise.all([
      fetch(
        "https://service.fetchcourses.ie/service/fetchcourse.svc/json/GetDeliveryCriteriaList"
      ).then((res) => res.json()),
      fetch(
        "https://service.fetchcourses.ie/service/fetchcourse.svc/json/GetISCEDList"
      ).then((res) => res.json()),
      fetch(
        `https://service.fetchcourses.ie/service/fetchcourse.svc/json/GetActiveCourseLocationList/0/${PROVIDER_ID}`
      ).then((res) => res.json()),
    ])
      .then(([deliveryCriteria, courseCategory, areaLists]) => {
        setData({
          courseType: deliveryCriteria.ReferenceList,
          interestArea: courseCategory.ReferenceList,
          areaList: areaLists.ReferenceList,
        });
        setLoading(false);

        // Check if selectedTime parameter is present in the URL
        const urlParams = new URLSearchParams(window.location.search);
        const selectedTime = urlParams.get('selectedTime');
        const selectedLocation = urlParams.get('selectedLocation');
        const keyword = urlParams.get('keyword');
        // If selectedTime is present, go directly to step 3
        if (selectedTime || keyword || selectedLocation) {
          // console.log({ selectedTime, keyword });
          // console.log(selectedLocation);
          selectedTime !== null && setSelectedDeliveryTime(selectedTime);
          selectedLocation !== null && setSelectedLocation(selectedLocation);
          keyword !== null && setInputSearch(keyword)
          setCurrentStep(3);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });

  }, []);
  if (loading) return <Preloader />;
  return (
    <div className="stepper" id='course-form-react'>
      {/* header of stepper */}
      <div className="header-stepper">
        <div onClick={() => setCurrentStep(1)} className="d-flex align-items-center  justify-content-center flex-column">
          <div className={`step-number ${currentStep === 1 ? "active" : ""} ${isStepCompleted(1) ? "completed" : ""}`}>
            {isStepCompleted(1) ? <img src={CheckSVG} alt="Check" /> : "1"}
          </div>
          <p className='step-heading-title'>Course Type</p>
          <span className="step-title-edit">{isStepEditable(1) ? "Edit" : ""}</span>
        </div>
        <Line />
        <div onClick={() => setCurrentStep(2)} className="d-flex align-items-center  justify-content-center flex-column">
          <div className={`step-number ${currentStep === 2 ? "active" : ""} ${isStepCompleted(2) ? "completed" : ""}`}>
            {isStepCompleted(2) ? <img src={CheckSVG} alt="Check" /> : "2"}
          </div>
          <p className='step-heading-title'>Area of Interest</p>
          <span className="step-title-edit">{isStepEditable(2) ? "Edit" : ""}</span>
        </div>
        <div className="step-divider dashed"></div>
        <div onClick={() => setCurrentStep(3)} className="d-flex align-items-center  justify-content-center flex-column">
          <div
            className={`step-number ${currentStep === 3 ? "active" : ""} ${isStepCompleted(3) ? "completed" : ""}`}>
            {isStepCompleted(3) ? <img src={CheckSVG} alt="Check" /> : "3"}
          </div>
          <p className='step-heading-title'>Search Result</p>
        </div>
      </div>
      {/* header of stepper ends*/}

      {/* stepper body starts */}
      <div className="stepper-body">
        {currentStep === 1 && (
          <Stepper1
            data={data}
            handleNext={handleNext}
            selectedCourseType={selectedCourseType}
            handleCourseTypeSelection={handleCourseTypeSelection}
            selectedDeliveryTime={selectedDeliveryTime}
            handleCheckboxChange={handleCheckboxChange}
          />
        )}
        {currentStep === 2 && (
          <Stepper2
            data={data}
            selectedInterestArea={selectedInterestArea}
            handleInterestAreaSelection={handleInterestAreaSelection}
            handleNext={handleNext}
            handlePrevious={handlePrevious}
          />
        )}
        {currentStep === 3 && (
          <Stepper3
            handlePrevious={handlePrevious}
            searchResults={searchResults}
            data={data}
          >
            <CourseFormCard
              data={data}
              setSearchResults={setSearchResults}
              deliveryTime={selectedDeliveryTime}
              inputSearch={inputSearch}
              handleSearch={handleSearch}
              courseType={selectedCourseType}
              handleCourseTypeSelection={handleCourseTypeSelection}
              interestArea={selectedInterestArea}
              handleInterestAreaSelection={handleInterestAreaSelection}
              selectedLocation={selectedLocation}
              handleLocationSelection={handleLocationSelection}
            />
          </Stepper3>
        )}
      </div>
    </div>
  );
};